import React, { useState } from 'react';
import { UserAuth } from '../../../authentication/AuthContext.jsx';
import { SecondaryButton } from "../../../components/button/Button.jsx";
import GoogleIconSrc from "../../../assets/common/static-icons/google.svg";
import MicrosoftIconSrc from "../../../assets/common/static-icons/microsoft.svg";

const ThirdPartyLogins = ({ onSuccess, onError, disabled }) => {
    const { signInWithGoogle, signInWithMicrosoft } = UserAuth();
    const [signingIn, setSigningIn] = useState(null);

    const handleGoogleSignIn = async () => {
        setSigningIn('google');
        try {
            const userCredential = await signInWithGoogle();
            onSuccess(userCredential.user);
        } catch (error) {
            let errorMessage = "Google sign-in failed.";
            if (error.code === 'auth/account-exists-with-different-credential') {
                errorMessage = 'The account already exists with a different credential.';
            }
            onError(errorMessage);
        } finally {
            setSigningIn(null);
        }
    };

    const handleMicrosoftSignIn = async () => {
        setSigningIn('microsoft');
        try {
            const userCredential = await signInWithMicrosoft();
            onSuccess(userCredential.user);
        } catch (error) {
            let errorMessage = "Microsoft sign-in failed.";
            if (error.code === 'auth/account-exists-with-different-credential') {
                errorMessage = 'The account already exists with a different credential.';
            }
            onError(errorMessage);
        } finally {
            setSigningIn(null);
        }
    };

    return (
        <div className="login-signup-form-container-section">
            <SecondaryButton
                onClick={handleGoogleSignIn}
                tone='neutral'
                disabled={disabled || !!signingIn}
                isFullWidth
                icon={<img src={GoogleIconSrc} alt="" />}
            >
                {signingIn === 'google' ? 'Signing In...' : 'Login with Google'}
            </SecondaryButton>
            <SecondaryButton
                onClick={handleMicrosoftSignIn}
                tone='neutral'
                disabled={disabled || !!signingIn}
                isFullWidth
                icon={<img src={MicrosoftIconSrc} alt="" />}
            >
                {signingIn === 'microsoft' ? 'Signing In...' : 'Login with Microsoft'}
            </SecondaryButton>
        </div>
    );
};

export default ThirdPartyLogins;